module.exports = __webpack_public_path__ + "img/901277186.5e69cceb.png";